import type {State} from '../../../reducers/types'
import {getBuildCanceledInfo} from '../../../selectors'
import type {BuildId} from '../../../types'

export const getIsInterrupted = (state: State, buildId: BuildId): boolean =>
  getBuildCanceledInfo(state, buildId) != null
